import { render, staticRenderFns } from "./OpcionesDropdownTableComponent.vue?vue&type=template&id=3ebd310e"
import script from "./OpcionesDropdownTableComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OpcionesDropdownTableComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports